module.exports = __webpack_public_path__ + "static/media/p208vid1.dbb00920.mp4";